import { render, staticRenderFns } from "./Aulas.vue?vue&type=template&id=72a1282d&"
import script from "./Aulas.vue?vue&type=script&lang=js&"
export * from "./Aulas.vue?vue&type=script&lang=js&"
import style0 from "./Aulas.vue?vue&type=style&index=0&id=72a1282d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports